import { memo } from 'react';

/**
 * Header component
 * @returns {ReactElement}
 */
const Header = (): React.ReactElement => {
  return (
    <dst-header
      appid="abo"
      variant="default"
    >
      <span slot="notifications"></span>
    </dst-header>
  );
};

const MemoizedHeader = memo(Header);
export { MemoizedHeader as Header };
